import { render, staticRenderFns } from "./Tools.vue?vue&type=template&id=a2275656&scoped=true"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"
import style0 from "./Tools.vue?vue&type=style&index=0&id=a2275656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2275656",
  null
  
)

export default component.exports